import { FormattedMessage } from 'react-intl'
import { array, object, string } from 'yup'

import messages from './messages'

export const schemaValidation = (values: any) => {
  // @ts-expect-error
  const stringSchema = string().required(<FormattedMessage {...messages.requiredError} />)
  // @ts-expect-error
  const iconUrlSchema = string().required(<FormattedMessage {...messages.requiredError} />)

  const schema = {
    currentApp: object().shape({
      name: stringSchema,
      iconUrl: iconUrlSchema
    }),
    currentConnector: object().shape({
      name: stringSchema,
      webHookUrl: string()
        .trim()
        // @ts-expect-error
        .url(<FormattedMessage {...messages.invalidUrl} />),
      iconUrl: iconUrlSchema
    }),
    currentMicroapp: object().shape({
      title: stringSchema,
      summary: stringSchema,
      url: string()
        .trim()
        // @ts-expect-error
        .required(<FormattedMessage {...messages.requiredError} />)
        // @ts-expect-error
        .url(<FormattedMessage {...messages.invalidUrl} />),
      configuration: object().shape({
        // @ts-expect-error
        allowDetailExpand: string().required(<FormattedMessage {...messages.requiredRadioButtonError} />),
        contact: object().shape({
          link: string()
            .trim()
            // @ts-expect-error
            .test('isEmailOrUrl', <FormattedMessage {...messages.invalidContactUrl} />, value => {
              const urlSchema = string().url()
              const isUrl = urlSchema.isValidSync(value)

              const emailSchema = string().email()
              const isEmail = emailSchema.isValidSync(value)

              const isLinkValid = isUrl || isEmail
              return isLinkValid
            })
            // @ts-expect-error
            .required(<FormattedMessage {...messages.requiredError} />)
        }),
        newDomainAddress: string()
          .trim()
          // @ts-expect-error
          .url(<FormattedMessage {...messages.invalidUrl} />),
        editableAddress: object().shape({
          address: string()
            .trim()
            // @ts-expect-error
            .url(<FormattedMessage {...messages.invalidUrl} />)
        })
      }),
      audience: array().of(
        object().shape({
          filters: array().of(
            object().shape({
              attribute: object().shape({
                // @ts-expect-error
                displayName: string().required(<FormattedMessage {...messages.requiredError} />),
                // @ts-expect-error
                scimAttributeName: string().required(<FormattedMessage {...messages.requiredError} />),
                // @ts-expect-error
                urn: string().required(<FormattedMessage {...messages.requiredError} />)
              }),
              // @ts-expect-error
              operator: string().required(<FormattedMessage {...messages.requiredError} />),
              // @ts-expect-error
              value: string().required(<FormattedMessage {...messages.requiredError} />)
            })
          )
        })
      )
    })
  }
  const { currentApp, currentConnector, currentMicroapp } = schema
  return object().shape({
    currentApp,
    ...(values.isSmartNotificationsExpanded && { currentConnector }),
    ...(values.isMicroUIExpanded && { currentMicroapp })
  })
}
